module.exports = __webpack_public_path__ + "img/baby.b4df7038.svg";